import { notification } from "antd";
import { publicAPI, attachToken, version } from "../../Config/Constant";
import store from "../store";
import { useNavigate } from "react-router-dom";

export const SETUSERDETAILS = (payload) => {
  return {
    type: "SET_USER_DETAILS",
    payload: payload,
  };
};

export const authSignup = async (payload, navigate) => {
  try {
    const res = await publicAPI.post("/auth/register", payload);
    if (res) {
      localStorage.setItem("version", version);
      localStorage.setItem("email", payload.email);
      localStorage.setItem(
        "organizationid",
        res?.data?.data?.data?.member?.organization_id
      );
      
      attachToken();
      notification.success({
        description: res.data.data.message,
        duration: 2,
      });

      navigate("/emailsent");
    }
  } catch (err) {
    notification.error({
      message: err?.response?.data?.message || "Server Error",
      duration: 3,
    });
  }
};

export const authPassword = async (payload, navigate) => {
  try {
    const res = await publicAPI.post("/auth/password-create", payload);

    if (res) {
      localStorage.setItem("sessiontoken", res.data.data.sessiontoken);
      attachToken();
      notification.success({
        description: res.data.data.message,
        duration: 2,
      });

      //   navigate('/authentication')
      navigate("/verfication");
    }
  } catch (err) {
    notification.error({
      message: err?.response?.data?.message || "Server Error",
      duration: 3,
    });
  }
};

export const authLogin = async (payload, navigate) => {
  try {
    const res = await publicAPI.post("/auth/login", payload);
    if (res) {
      if (res) {
        attachToken();
        localStorage.setItem("version", version);
        localStorage.setItem("token", res.data.data.token);
        localStorage.setItem(
          "organizationid",
          res?.data?.data?.user?.organizationid
        );
        localStorage.setItem("email", res?.data?.data?.user?.email);
        localStorage.setItem("isLoggedIn", true);
        localStorage.setItem("lastLoginTime", Date.now().toString());
        await getUser(res?.data?.data?.user?.organizationid);

        // localStorage.setItem('date', res?.data?.data?.setting?.date)

        notification.success({
          description: res.data.data.message,
          duration: 2,
        });

        // getUser()

        // store.dispatch(getUser())

        navigate("/dashboard/overview");
        return res;
        // }
      }
    }
  } catch (err) {
    console.error("Error during login:", err);
    notification.error({
      message: err?.response?.data?.message || "Server Error",
      duration: 3,
    });
  }
};

export const getUser = async (organizationid) => {
  try {
    attachToken();
    const res = await publicAPI.get(`/auth/get-user/${organizationid}`);
    if (res) {
      store.dispatch(SETUSERDETAILS(res.data.data));
    }
  } catch (err) {
    notification.error({
      message: err?.response?.data?.message || "Server Error",
      duration: 3,
    });
  }
};

export const UpdateProfile = async (payload) => {
  try {
    const res = await publicAPI.put("/auth/update-profile", payload);
    if (res) {
      await getUser();
      attachToken();
      notification.success({
        description: res.data.data.message,
        duration: 2,
      });
      return res;
    }
  } catch (err) {
    notification.error({
      message: err?.response?.data?.message || "Server Error",
      duration: 3,
    });
  }
};

export const SendOTP = async (payload) => {
  try {
    const res = await publicAPI.post("/auth/send-otp", payload);
    if (res) {
      attachToken();
      notification.success({
        description: res.data.data.message,
        duration: 2,
      });
      return res;
    }
  } catch (err) {
    notification.error({
      message: err?.response?.data?.message || "Server Error",
      duration: 3,
    });
  }
};

export const AutheticateOTP = async (payload, navigate) => {
  try {
    const res = await publicAPI.post("/auth/authenticateotp", payload);
    if (res) {
      // Store authentication data like regular login
      attachToken();
      localStorage.setItem("version", version);
      localStorage.setItem("token", res.data.data.token);
      localStorage.setItem(
        "organizationid",
        res?.data?.data?.user?.organizationid
      );
      localStorage.setItem("email", res?.data?.data?.user?.email);
      localStorage.setItem("isLoggedIn", true);
      localStorage.setItem("lastLoginTime", Date.now().toString());
      await getUser(res?.data?.data?.user?.organizationid);

      notification.success({
        description: res.data.data.message,
        duration: 2,
      });

      // Redirect directly to dashboard instead of success page
      navigate("/dashboard/overview");
    }
  } catch (err) {
    notification.error({
      message: err?.response?.data?.message || "Server Error",
      duration: 3,
    });
  }
};

export const getAllUser = async (payload) => {
  try {
    const res = await publicAPI.post("/auth/getallusers", payload);
    if (res) {
      attachToken();
      // notification.success({
      //   description: res.data.data.message,
      //   duration: 2,
      // })

      //  store.dispatch(SETALLUSERS(res.data.data))

      store.dispatch({
        type: "SETALLUSERS",
        payload: res.data.data,
      });
    }
  } catch (err) {
    notification.error({
      message: err?.response?.data?.message || "Server Error",
      duration: 3,
    });
  }
};

export const DeleteAccount = async (payload) => {
  try {
    const res = await publicAPI.delete(
      `/auth/delete_account/${payload?.organizationid}`
    );
    if (res) {
      notification.success({
        description: res.data.data.message,
        duration: 2,
      });
      localStorage.removeItem("token");
      localStorage.removeItem("email");
      localStorage.removeItem("organizationid");
      localStorage.removeItem("version");
      localStorage.removeItem("isLoggedIn");
      localStorage.removeItem("lastLoginTime");

      //   navigate('/authentication')
      return res;
    }
  } catch (err) {
    notification.error({
      message: err?.response?.data?.message || "Server Error",
      duration: 3,
    });
  }
};

export const Logout = () => {
  const navigate = useNavigate();

  localStorage.removeItem("token");
  localStorage.removeItem("email");
  localStorage.removeItem("organizationid");
  localStorage.removeItem("version");
  localStorage.removeItem("isLoggedIn");
  localStorage.removeItem("lastLoginTime");
  navigate("/");
};
